import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import Traductor from "../components/Traductor";
import ScrollToTop from "../components/ScrollToTop";

const PrivacyPolicyPage = () => {
  const t = new Traductor();

  return (
    <Fragment>
      <ScrollToTop></ScrollToTop>
      <div
        className="c-hero-teaser c-hero-teaser--no-image c-hero-teaser--auto"
        data-testid="privacyPolicyPageTestId"
      >
        <div className="c-hero-teaser__image"></div>
        <div
          id="js-hero-teaser-content"
          className="c-hero-teaser__content u-pt-small u-mt-none"
        >
          <div className="c-hero-teaser__content-inner">
            <header className="c-hero-teaser__heading">
              <div className="c-hero-teaser__title">
                <h1>
                  <span className="c-hero-teaser__title-row">
                    {t.getTraduction("PrivacyPolicy")}
                  </span>
                  <br />
                </h1>
              </div>
            </header>
          </div>
        </div>
      </div>

      <main className="o-main  ">
        <section className="o-content-section  u-pt-none">
          <div className="o-page-wrap  o-page-wrap--xxsmall">
            <p>
              <strong>
                {" "}
                ¿Quién es el responsable del tratamiento de sus datos
                personales?{" "}
              </strong>
            </p>
            <p>
              {" "}
              El responsable de tratamiento es el concesionario identificado en
              el contrato de alquiler del vehículo.{" "}
            </p>
            <p className="backspace-minus">&nbsp;</p>

            <p>
              <strong> ¿Con qué finalidad tratamos tus datos? </strong>
            </p>
            <p>
              {" "}
              Tratamos tus datos con el objetivo gestionar el contrato de
              alquiler, conservarlos para nuevos alquileres en el futuro, así
              como para enviarte informaciones comerciales de productos y
              servicios más adaptados a tus preferencias de los que te
              informaremos por medios electrónicos o por escrito.{" "}
            </p>
            <p>
              {" "}
              Si nos das tu consentimiento, podrás recibir nuestras ofertas
              personalizadas de productos y servicios ajustadas a tu perfil,
              basado en tu comportamiento y tus preferencias, utilizando, en su
              caso, fuentes externas, así como del uso que hagas de los
              productos o servicios, incluso una vez finalizado el servicio.{" "}
            </p>
            <p>
              Asimismo, dinos si deseas que comuniquemos tus datos al
              fabricante/importador del vehículo (Volkswagen Group España
              Distribución, S.A/ SEAT S.A.) y empresas de los servicios
              financieros del Grupo Volkswagen en España (Volkswagen Renting
              S.A., Volkswagen Bank GmbH Sucursal en España, Volkswagen
              Insurance Services Correduría de Seguros S.L., Man Financial
              Services España S.L.) para que te ofrezcan ventajas en sus
              productos y servicios:
            </p>

            <p>
              (i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Para que
              puedas disfrutar de todos los descuentos, novedades, productos y
              servicios, contactándote tanto por medios escritos como
              electrónicos.
            </p>
            <p>
              (ii)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Para que
              puedas recibir ofertas personalizadas de productos y servicios que
              se puedan determinar en función de tu perfil, basado en tu
              comportamiento y tus preferencias personales, utilizando en su
              caso, fuentes externas, así como del uso que hagas de los
              productos o servicios, incluso una vez finalizado el servicio.
            </p>
            <p className="backspace-minus">&nbsp;</p>

            <p>
              <strong>
                {" "}
                ¿Qué datos tratamos y de qué fuente se obtienen?{" "}
              </strong>
            </p>
            <p>
              {" "}
              Los datos que tratamos son los que nos hayas facilitado en la
              solicitud de alquiler y/o en el presente contrato de alquiler.{" "}
            </p>

            <p> Los datos que tratamos se refieren a: </p>
            <p>
              -&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Datos
              identificativos (p.ej., nombre y apellidos, documento de identidad
              o dirección de correo electrónico).
            </p>
            <p>
              -&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Datos de
              características personales (p.ej. fecha de nacimiento,
              nacionalidad).
            </p>
            <p>
              -&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Datos
              económicos, financieros y de seguros (p.ej. datos bancarios).
            </p>
            <p>
              -&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Datos de
              transacciones de bienes y servicios (p. ej. pagos de los servicios
              realizados).
            </p>
            <p>
              -&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Datos de
              información comercial (p.ej. intereses en productos o servicios).
            </p>
            <p className="backspace-minus">&nbsp;</p>

            <p>
              <strong> ¿Por qué tratamos tus datos? </strong>
            </p>
            <p>
              {" "}
              El tratamiento de datos se realiza sobre las siguientes bases
              legitimadoras:{" "}
            </p>
            <p>
              (i) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; El
              cumplimiento del contrato, para la gestion de los servicios
              solicitados así como para tramitar y gestionar cualquier solicitud
              que realices.
            </p>
            <p>
              (ii)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Cumplimiento
              de obligaciones legales.
            </p>
            <p>
              (iii)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;El interés
              legítimo del concesionario para enviarte ofertas y promociones
              ajustadas, en su caso, a tu perfil, por medios electrónicos o por
              escrito y conservar dichos datos personales para agilizar futuras
              solicitudes de nuevos alquileres.
            </p>
            <p>
              (iv)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Tu
              consentimiento para comunicar datos a otras empresas de las que
              recibirás ofertas y promociones personalizadas ajustadas a tus
              preferencias.
            </p>
            <p className="backspace-minus">&nbsp;</p>

            <p>
              <strong> ¿A quién comunicamos tus datos? </strong>
            </p>
            <p>
              {" "}
              Tus datos no se comunicarán a terceros salvo que exista una
              obligación legal o sea necesario para el mantenimiento y control
              del contrato.{" "}
            </p>
            <p>
              {" "}
              En aquellos casos, en los que nos hayas dado tu consentimiento
              conforme a las finalidades indicadas, tus datos serán comunicados
              al fabricante/importador del vehículo, y empresas de los servicios
              financieros del Grupo Volkswagen en España anteriormente
              indicadas.
            </p>
            <p className="backspace-minus">&nbsp;</p>

            <p>
              <strong>¿Por cuánto tiempo conservaremos tus datos?</strong>
            </p>
            <p>
              {" "}
              Los datos personales tratados para la ejecución del contrato,
              cumplimiento del interés legítimo y los otorgados con tu
              consentimiento, se conservarán mientras dure el contrato de
              alquiler así como el tiempo necesario para cumplir las
              obligaciones legales.{" "}
            </p>
            <p className="backspace-minus">&nbsp;</p>

            <p>
              <strong> ¿Cuáles son tus derechos? </strong>
            </p>
            <p>
              {" "}
              Puedes retirar tu consentimiento en cualquier momento y/o
              solicitar el acceso a tus datos personales, la rectificación de
              los datos inexactos o, en su caso, solicitar su supresión,
              oposición, portabilidad y limitación del tratamiento de los datos
              ante el concesionario por correo postal o a la dirección de correo
              electrónico que consta en el contrato.{" "}
            </p>
            <p>
              {" "}
              Asimismo, podrás dirigirte a la Agencia Española de Protección de
              Datos.{" "}
            </p>
            <p>
              {" "}
              Si nos facilitas datos de otras personas, declaras haberles
              informado previamente sobre el tratamiento de sus datos para las
              finalidades indicadas en el presente documento, todas ellas
              basadas en la gestión de la relación contractual, de cumplimiento
              de obligaciones legales y/o interés legítimo del
              Concesionario-arrendador, circunstancia que si te lo solicitamos
              deberás poder demostrar.{" "}
            </p>
          </div>
        </section>
      </main>
    </Fragment>
  );
};
export default withRouter(PrivacyPolicyPage);
